function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M7 6.54523C8.32608 6.54523 9.59785 7.07202 10.5355 8.0097C11.4732 8.94738 12 10.2192 12 11.5452V12H2.45476C2.33415 12 2.21848 11.9521 2.1332 11.8668C2.04791 11.7815 2 11.6658 2 11.5452C2 10.2192 2.52678 8.94738 3.46447 8.0097C4.40215 7.07202 5.67392 6.54523 7 6.54523V6.54523Z",
  strokeWidth: 2
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17.4548 7C17.4548 7.65661 17.3254 8.30679 17.0742 8.91342C16.8229 9.52004 16.4546 10.0712 15.9903 10.5355C15.526 10.9998 14.9748 11.3681 14.3682 11.6194C13.7616 11.8707 13.1114 12 12.4548 12H12V2.45476C12 2.33415 12.0479 2.21848 12.1332 2.1332C12.2185 2.04791 12.3342 2 12.4548 2C13.1114 2 13.7616 2.12933 14.3682 2.3806C14.9748 2.63188 15.526 3.00017 15.9903 3.46447C16.4546 3.92876 16.8229 4.47996 17.0742 5.08658C17.3254 5.69321 17.4548 6.34339 17.4548 7Z",
  strokeWidth: 2
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 17.4548C15.6739 17.4548 14.4021 16.928 13.4645 15.9903C12.5268 15.0526 12 13.7808 12 12.4548V12H21.5452C21.6658 12 21.7815 12.0479 21.8668 12.1332C21.9521 12.2185 22 12.3342 22 12.4548C22 13.7808 21.4732 15.0526 20.5355 15.9903C19.5979 16.928 18.3261 17.4548 17 17.4548V17.4548Z",
  strokeWidth: 2
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.54541 17C6.54541 15.6739 7.07219 14.4021 8.00988 13.4645C8.94756 12.5268 10.2193 12 11.5454 12H12.0002V21.5452C12.0002 21.6658 11.9523 21.7815 11.867 21.8668C11.7817 21.9521 11.666 22 11.5454 22C10.2193 22 8.94756 21.4732 8.00988 20.5355C7.07219 19.5979 6.54541 18.3261 6.54541 17V17Z",
  strokeWidth: 2
});

function SvgGoogleMonochrome(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather",
    ref: svgRef
  }, props), _ref, _ref2, _ref3, _ref4);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMonochrome);
export default __webpack_public_path__ + "static/media/google-monochrome.7f80b894.svg";
export { ForwardRef as ReactComponent };